// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TopicCardTemplateOption\ApiTopicCardTempateOptions.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { TopicCardTemplate, TopicCardTemplateData, TopicCardTemplateOptions } from 'data/models/TopicCardTemplate';

// TopicCardTemplateOptionData is the class that TopicCardTemplateOption serializes to/from
export interface TopicCardTemplateOptionData {
    Id : number;
    Url : string | null;
	
    Template : TopicCardTemplateData | null;
    TemplateId : number;
	
    DisplayOrder : number;
    Guid : /* GUID */ string;
    Text : string;
}

// TopicCardTemplateOptionOptions is the class which may be passed to the TopicCardTemplateOption constructor to define optional initial data values
export interface TopicCardTemplateOptionOptions {
    Id : number;
    Url? : string | null;
	
    Template? : TopicCardTemplateOptions | null;
    TemplateId? : number;
	
    DisplayOrder? : number;
    Guid? : /* GUID */ string;
    Text? : string;
}

export class TopicCardTemplateOption {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Template : DataSignal<TopicCardTemplate | null>;
    public TemplateId : DataSignal<number>;
	
    public DisplayOrder : DataSignal<number>;
    public Guid : DataSignal<string>;
    public Text : DataSignal<string>;

    constructor();
    constructor(data : TopicCardTemplateOptionOptions);
    constructor(data: TopicCardTemplateOptionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Template = S.value<TopicCardTemplate | null>(null);
        this.TemplateId = jsonableObservable(S.value<number>(data && data.TemplateId !== undefined ? data.TemplateId : 0));
	    
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.Text = jsonableObservable(S.value<string>(data && data.Text !== undefined ? data.Text : ''));
    }

    static key(obj : TopicCardTemplateOption) {
        return obj.Id();
    }
    
    static dataKey(obj : TopicCardTemplateOptionOptions) {
        return obj.Id;
    }

    static update(obj : TopicCardTemplateOption, data : TopicCardTemplateOptionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.TemplateId !== undefined) obj.TemplateId(data.TemplateId);
	        
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.Text !== undefined) obj.Text(data.Text);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardTemplateOption.ts